import React from 'react';
import loadable from '@loadable/component';
import Slider from 'react-slick';

import CCShowcasePng01 from '../../../assets/images/products/showcase/CC/CC-product-showcase-01.jpg';
import CCShowcaseWebp01 from '../../../assets/images/products/showcase/CC/CC-product-showcase-01.jpg?=webp';
import CCShowcaseSmallPng01 from '../../../assets/images/products/showcase/CC/CC-product-showcase-small-01.jpg';
import CCShowcaseSmallWebp01 from '../../../assets/images/products/showcase/CC/CC-product-showcase-small-01.jpg?=webp';

import CCShowcasePng02 from '../../../assets/images/products/showcase/CC/CC-product-showcase-02.jpg';
import CCShowcaseWebp02 from '../../../assets/images/products/showcase/CC/CC-product-showcase-02.jpg?=webp';

import CCShowcasePng03 from '../../../assets/images/products/showcase/CC/CC-product-showcase-03.jpg';
import CCShowcaseWebp03 from '../../../assets/images/products/showcase/CC/CC-product-showcase-03.jpg?=webp';

import CCShowcasePng04 from '../../../assets/images/products/showcase/CC/CC-product-showcase-04.jpg';
import CCShowcaseWebp04 from '../../../assets/images/products/showcase/CC/CC-product-showcase-04.jpg?=webp';

const ImageLoader = loadable(() => import('../common/ImageLoader'));
const OrderCard = loadable(() => import('./OrderCard'));
const ServicesList = loadable(() => import('./ServicesList'));

const showcaseImages = [
  {
    id: 'cc-showcase-01',
    baseUrl: CCShowcasePng01,
    webpUrl: CCShowcaseWebp01,
    baseUrlSmall: CCShowcaseSmallPng01,
    webpUrlSmall: CCShowcaseSmallWebp01,
    alt: 'The Critter Cuddler product showcase',
    width: 620,
    height: 462,
  },
  {
    id: 'cc-showcase-02',
    baseUrl: CCShowcasePng02,
    webpUrl: CCShowcaseWebp02,
    baseUrlSmall: null,
    webpUrlSmall: null,
    alt: 'The Critter Cuddler app showcase',
    width: 620,
    height: 462,
  },
  {
    id: 'cc-showcase-03',
    baseUrl: CCShowcasePng03,
    webpUrl: CCShowcaseWebp03,
    baseUrlSmall: null,
    webpUrlSmall: null,
    alt: 'The Critter Cuddler Mila showcase',
    width: 620,
    height: 462,
  },
  {
    id: 'cc-showcase-04',
    baseUrl: CCShowcasePng04,
    webpUrl: CCShowcaseWebp04,
    baseUrlSmall: null,
    webpUrlSmall: null,
    alt: 'The Critter Cuddler unbox showcase',
    width: 620,
    height: 462,
  },
];

const ProductShowcase = () => {
  const settings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    focusOnSelect: true,
    cssEase: 'ease-in-out',
  };

  return (
    <Slider
      className='product-showcase'
      {...settings}
      style={{ '--primary-color': '#F42C52' }}
    >
      {showcaseImages.map(image => (
        <div className='product-showcase__item' key={image.id}>
          <ImageLoader
            className='product-showcase__image img-relative'
            placeholderAspectRatio={image.width / image.height}
            image={image.baseUrl}
            webp={image.webpUrl}
            smallImage={image.baseUrlSmall}
            smallWebp={image.webpUrlSmall}
            alt={image.alt}
          />
        </div>
      ))}
    </Slider>
  );
};

const ProductOrder = ({ type, localization }) => (
  <div
    className='product-order'
    style={{ '--primary-color': ' #F42C52', '--secondary-color': '#FFF2F5' }}
  >
    <div className='container container--md'>
      <div className='product-order__grid'>
        <div className='product-order__content'>
          <h2 className='product-order__title'>Say hello to Mila</h2>
          <div className='product-order__description'>
            <p>
              Ever met an air purifier you truly loved? Neither had we. So we
              created Mila—the first air purifier designed with real,
              air-breathing humans in mind. Unlike traditional air purifiers
              that come with three manual speeds and a button called auto, Mila
              is a truly smart air purifier that’s light years ahead.
            </p>
          </div>
          <ProductShowcase />
        </div>
        <div className='order-wrapper'>
          <OrderCard type={type} localization={localization} />
          <ServicesList />
        </div>
      </div>
    </div>
  </div>
);

export default ProductOrder;
